import { useContext } from 'react'
import { ReactReduxContext } from 'react-redux'
import type { Store } from '@reduxjs/toolkit'
import type { RootState } from '@/store'

/**
 * Стор для чтения В МОМЕНТ действия (а не из замыкания рендера). Без провайдера
 * (тесты хуков на моках `@/store/hooks`) — `null`: вызывающий считает, что
 * читать нечего, и ведёт себя по-старому.
 */
export const useOptionalStore = (): Store<RootState> | null => {
  const ctx = useContext(ReactReduxContext)
  return (ctx?.store as Store<RootState> | undefined) ?? null
}
